 
import { useEffect, useState } from "react";

const BASE_URL = "https://be-ofertas.utpl.edu.ec";

const DataFetcherTemplateHome = ({ url, children }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Obtener UNA imagen
  const getImageUrl = (node, included, fieldName) => {
    const mediaId = node.relationships?.[fieldName]?.data?.id;
    if (!mediaId) return null;

    const media = included.find(
      (item) => item.type === "media--image" && item.id === mediaId,
    );

    const fileId = media?.relationships?.field_media_image?.data?.id;
    if (!fileId) return null;

    const file = included.find(
      (item) => item.type === "file--file" && item.id === fileId,
    );

    return file?.attributes?.uri?.url
      ? BASE_URL + file.attributes.uri.url
      : null;
  };

  // Obtener MUCHAS imágenes
  const getImageUrls = (node, included, fieldName) => {
    const mediaItems = node.relationships?.[fieldName]?.data;
    if (!Array.isArray(mediaItems)) return [];

    return mediaItems
      .map((item) => {
        const media = included.find(
          (inc) => inc.type === "media--image" && inc.id === item.id,
        );

        const fileId = media?.relationships?.field_media_image?.data?.id;

        const file = included.find(
          (inc) => inc.type === "file--file" && inc.id === fileId,
        );

        return file?.attributes?.uri?.url
          ? BASE_URL + file.attributes.uri.url
          : null;
      })
      .filter(Boolean);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!url) throw new Error("URL no proporcionada");

        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`Error ${response.status}`);
        }

        const json = await response.json();

        console.log("API RESPONSE:", json);

        const node = Array.isArray(json?.data)
          ? json.data[0]
          : json.data;

        const atributos = node?.attributes;
        const included = json?.included || [];

        if (!atributos) {
          throw new Error("Estructura inesperada de la API");
        }

        // Imagen principal
        const imagePortada = getImageUrl(
          node,
          included,
          "field_imagen_portada",
        );

        // Bloques automáticos (field_bloque1, field_bloque2...)
        const bloques = Object.keys(atributos)
          .filter((key) => key.startsWith("field_bloque"))
          .sort((a, b) => {
            const numA = parseInt(a.match(/\d+/)?.[0] || 0);
            const numB = parseInt(b.match(/\d+/)?.[0] || 0);
            return numA - numB;
          })
          .reduce((acc, key) => {
            const nombreBloque = key.replace("field_", "");
            acc[nombreBloque] = atributos[key]?.processed || "";
            return acc;
          }, {});

        // Imágenes automáticas (field_imagen1, field_imagen2...)
        const imagenes = Object.keys(node.relationships || {})
          .filter(
            (key) =>
              key.startsWith("field_imagen") &&
              key !== "field_imagen_portada",
          )
          .sort((a, b) => {
            const numA = parseInt(a.match(/\d+/)?.[0] || 0);
            const numB = parseInt(b.match(/\d+/)?.[0] || 0);
            return numA - numB;
          })
          .reduce((acc, key) => {
            const nombreImagen = key.replace("field_", "");
            acc[nombreImagen] = getImageUrl(node, included, key) || "";
            return acc;
          }, {});

        const cleanData = {
          id: node.id,
          titulo: atributos.title,
          texto_portada: atributos.field_texto_portada?.processed || "",

          // Bloques automáticos
          ...bloques,

          // Imágenes automáticas
          ...imagenes,

          imagen_portada: imagePortada || "",

          // Galería
          galeria: getImageUrls(node, included, "field_gallery"),
        };

        console.log("DATA LIMPIA:", cleanData);

        setData(cleanData);
      } catch (err) {
        console.error("FETCH ERROR:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url]);

  if (loading) return <p>Cargando...</p>;
  if (error) return <p>Error: {error}</p>;

  return children(data);
};

export default DataFetcherTemplateHome;

